import { render, staticRenderFns } from "./FaqsDetail.vue?vue&type=template&id=138668aa&"
import script from "./FaqsDetail.vue?vue&type=script&lang=js&"
export * from "./FaqsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports